import { Autocomplete, Field } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './shared-capital-filter.module.scss';

import moment from 'moment';

const CustomerAccountDetailModalFilter = ({ filterState, onYearChange }) => {
  const onYearChangeCb = useCallback(
    (name, { value }) => {
      if (onYearChange) return onYearChange(value || (moment().year() - 1).toString());
    },
    [onYearChange]
  );

  return (
    <div className={styles.filter}>
      <div className={styles.filterContent}>
        <Field className={styles.status} label="Year">
          <Autocomplete
            name="year"
            value={filterState.year}
            options={[
              { label: '2025', value: '2025' },
              { label: '2024', value: '2024' }
            ]}
            onChange={onYearChangeCb}
          />
        </Field>
        {/* <Field className={styles.search} label="Search">
          <SearchField
            placeholder={'Customer Account Number, Name'}
            value={filterState.searchKey}
            onChange={onSearchChangeCb}
            onEnter={onSearchCb}
            restrict={false}
          />
        </Field> */}
      </div>
    </div>
  );
};

export default CustomerAccountDetailModalFilter;
